import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'preact-iso';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import MojitoCore from 'mojito/core';
import HomePage from 'applications/sports/pages/home-page/index.js';
import EventPage from 'applications/sports/pages/event-page/index.js';

const { useLocalizedParams, usePreviousValue } = MojitoPresentation.Hooks;
const {
    selectors: { selectEventId, isLoaded },
    actions: notificationEventActions,
} = MojitoServices.SportsContent.NotificationEvent;
const { useAppContext } = MojitoCore.Presentation.Hooks;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;

function InplayEventController(props) {
    const {
        mojitoTools: { config },
    } = props;
    const { notificationsIdSearchParam = {} } = config;
    const { isInplayRoute: isInplayPage } = props;
    const { query } = useLocation();
    const { eventId } = useLocalizedParams();
    const previousEventId = usePreviousValue(eventId);

    if (query[notificationsIdSearchParam.name] === notificationsIdSearchParam.value) {
        return <NotificationEventController />;
    }

    const shouldScrollTop = previousEventId !== eventId;

    return <EventPage autoScrollTop={shouldScrollTop} isInplayPage={isInplayPage} />;
}

function NotificationEventController() {
    const dispatch = useDispatch();
    const { query, route } = useLocation();
    const { eventId: notificationsEventId } = useLocalizedParams();
    const { routeResolver } = useAppContext();

    useEffect(() => {
        dispatch(notificationEventActions.getEventId(notificationsEventId));
    }, [notificationsEventId, dispatch]);

    const loaded = useSelector(state => isLoaded(notificationsEventId, state));
    const eventId = useSelector(state => selectEventId(notificationsEventId, state));

    useEffect(() => {
        if (!loaded) {
            return;
        }
        const targetUrl = eventId
            ? NavigationPathBuilder.inplayEventPath(eventId, routeResolver)
            : NavigationPathBuilder.inplayPath(undefined, routeResolver);

        const paramsString = new URLSearchParams(query).toString();
        // Redirect instead of using intentions - in order to change search param along with URL
        route(paramsString ? `${targetUrl}?${paramsString}` : targetUrl);
    }, [loaded, eventId, query, route, routeResolver]);

    if (loaded) {
        return null;
    }

    return <HomePage />;
}

export default InplayEventController;
